import { useQuery } from '@tanstack/react-query';
import { caseApplicationsService, GET_CASES_CLIENTS } from '@/api';
import { StatusCase } from '@/interfaces';

// Client-facing case steps in flow order; mirrors the `StatusCase` union.
const CASE_STEP_ORDER: StatusCase[] = [
	'Claim submitted',
	'Application in review',
	'Documents required',
	'Application approved',
	'Sign retainer',
	'Review complaint',
	'Review Demand Letter',
	'Case initiated',
	'Case in progress',
	'Accept settlement',
	'Payment details',
	'Case resolved',
];

const ADVANCED_FROM_INDEX = CASE_STEP_ORDER.indexOf('Sign retainer');

const isAdvancedStep = (step: StatusCase): boolean =>
	CASE_STEP_ORDER.indexOf(step) >= ADVANCED_FROM_INDEX;

/** True when any of the client's cases has reached the retainer step or beyond. */
export const useHasAdvancedCase = (enabled = true) => {
	return useQuery({
		queryKey: [GET_CASES_CLIENTS, 'has-advanced-case'],
		queryFn: () => caseApplicationsService.getAll({ page: 1, limit: 100 }),
		select: (response) =>
			response.data.items.some((item) => isAdvancedStep(item.step_name)),
		enabled,
	});
};
